import { render, staticRenderFns } from "./OrderRelatedLawyerPart.vue?vue&type=template&id=33a4c3b6&scoped=true&"
import script from "./OrderRelatedLawyerPart.vue?vue&type=script&lang=js&"
export * from "./OrderRelatedLawyerPart.vue?vue&type=script&lang=js&"
import style0 from "./OrderRelatedLawyerPart.vue?vue&type=style&index=0&id=33a4c3b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33a4c3b6",
  null
  
)

/* custom blocks */
import block0 from "./OrderRelatedLawyerPart.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports